const Repo = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.441 15.145C18.275 13.962 17.652 11.938 15.354 11.066C13 10.171 13 9.466 13 9V8.837C14.44 8.403 15.5 7.08 15.5 5.5C15.5 3.57 13.93 2 12 2C10.07 2 8.5 3.57 8.5 5.5C8.5 7.08 9.56 8.403 11 8.837V9C11 9.466 11 10.171 8.646 11.065C6.348 11.937 5.725 13.961 5.559 15.144C4.088 15.559 3 16.898 3 18.5C3 20.43 4.57 22 6.5 22C8.43 22 10 20.43 10 18.5C10 16.948 8.978 15.645 7.576 15.187C7.722 14.452 8.141 13.396 9.354 12.935C10.546 12.483 11.407 11.982 12 11.399C12.593 11.982 13.453 12.483 14.646 12.935C15.859 13.396 16.279 14.452 16.424 15.187C15.022 15.645 14 16.948 14 18.5C14 20.43 15.57 22 17.5 22C19.43 22 21 20.43 21 18.5C21 16.898 19.912 15.559 18.441 15.145ZM6.5 20C5.673 20 5 19.327 5 18.5C5 17.673 5.673 17 6.5 17C7.327 17 8 17.673 8 18.5C8 19.327 7.327 20 6.5 20ZM10.5 5.5C10.5 4.673 11.173 4 12 4C12.827 4 13.5 4.673 13.5 5.5C13.5 6.327 12.827 7 12 7C11.173 7 10.5 6.327 10.5 5.5ZM17.5 20C16.673 20 16 19.327 16 18.5C16 17.673 16.673 17 17.5 17C18.327 17 19 17.673 19 18.5C19 19.327 18.327 20 17.5 20Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Repo;
